import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import { QUERYSTRING_IFRAMEURL } from '../constants';
var MYPAGES_NETWORK_URL = '/mypages/network';
var MEMBER_CONSULTANT_TYPE = 11;

/* Merge menus, sitecore items will overwrite same on eshop */
var mapOrisalesToInternalMenuItems = function mapOrisalesToInternalMenuItems(parentItemPath, items) {
  return items.map(function (item, index) {
    var _item$Items;
    var itemPath = "".concat(parentItemPath, "/").concat(index, "/");
    var subItems = (_item$Items = item.Items) !== null && _item$Items !== void 0 ? _item$Items : [];
    if (subItems.length && item.Url) {
      subItems = [{
        Name: item.Name,
        Url: item.Url
      }].concat(_toConsumableArray(subItems));
    }
    return {
      itemPath: itemPath,
      title: item.Name,
      url: item.Url,
      icon: null,
      subItems: mapOrisalesToInternalMenuItems(itemPath, subItems)
    };
  });
};

/* Find position for merging */
var findSameNodeIndex = function findSameNodeIndex(currentMenu, newMenuNode) {
  return currentMenu.findIndex(function (currentMenuNode) {
    return newMenuNode.title && currentMenuNode.title && newMenuNode.title.trim().toLowerCase() === currentMenuNode.title.trim().toLowerCase();
  });
};
var setupSubItemsItemPaths = function setupSubItemsItemPaths(itemPath, menuItems) {
  var _iterator = _createForOfIteratorHelper(menuItems.entries()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        i = _step$value[0],
        subItem = _step$value[1];
      subItem.itemPath = "".concat(itemPath, "/").concat(i, "/");
      if (subItem.subItems.length > 0) {
        setupSubItemsItemPaths(subItem.itemPath, subItem.subItems);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};

/* Merge new node to existings menu, recursive */
var mergeToNode = function mergeToNode(currentMenu, newMenu, parentItemPath, rootItemUrl, consultantType, reportsItemName) {
  var _iterator2 = _createForOfIteratorHelper(newMenu),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var newMenuNode = _step2.value;
      var shouldSkipForMember = consultantType === MEMBER_CONSULTANT_TYPE && rootItemUrl === MYPAGES_NETWORK_URL && newMenuNode.title === reportsItemName;
      if (shouldSkipForMember) {
        continue;
      }
      var relatedNodeIndex = findSameNodeIndex(currentMenu, newMenuNode);
      if (relatedNodeIndex !== -1) {
        // needs to merge, subitems
        if (newMenuNode.subItems.length > 0) {
          var parentNode = currentMenu[relatedNodeIndex];
          if (parentNode !== undefined) {
            var subItems = parentNode.subItems,
              itemPath = parentNode.itemPath;
            if (subItems.length > 0) {
              mergeToNode(subItems, newMenuNode.subItems, itemPath, rootItemUrl, consultantType, reportsItemName);
            }
          }
        }
      } else if (newMenuNode.subItems.length > 0 || newMenuNode.url) {
        var _itemPath = "".concat(parentItemPath, "/").concat(currentMenu.length, "/");
        newMenuNode.itemPath = _itemPath;
        if (newMenuNode.subItems.length > 0) {
          setupSubItemsItemPaths(_itemPath, newMenuNode.subItems);
        }
        // needs to add, subitems
        currentMenu.push(newMenuNode);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
};
export var mergeEshop = function mergeEshop(menuItems, eshopData, consultantType, reportsItemName) {
  if (!eshopData.Items) {
    return;
  }
  var personalMenuEshop = mapOrisalesToInternalMenuItems('', eshopData.Items);

  // Merge root items
  var _iterator3 = _createForOfIteratorHelper(personalMenuEshop),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var newMenuNode = _step3.value;
      var relatedRootIndex = findSameNodeIndex(menuItems, newMenuNode);
      if (relatedRootIndex !== -1) {
        var parentNode = menuItems[relatedRootIndex];
        if (parentNode !== undefined) {
          (function () {
            var parentUrl = parentNode.url;

            // modify eshop iframe links - also in all subitems
            var rootItemStr = JSON.stringify(newMenuNode);
            rootItemStr = rootItemStr.replace(/"url":"(.*?)"/g, function (_, url) {
              var encodedParam = encodeURIComponent(url);
              return "\"url\":\"".concat(parentUrl, "?").concat(QUERYSTRING_IFRAMEURL, "=").concat(encodedParam, "\"");
            });
            var adjustedNode = JSON.parse(rootItemStr);

            // Merge both menus
            var subItems = parentNode.subItems,
              itemPath = parentNode.itemPath;
            if (relatedRootIndex !== -1 && adjustedNode.subItems.length > 0 && subItems.length > 0) {
              mergeToNode(subItems, adjustedNode.subItems, itemPath, parentUrl, consultantType, reportsItemName);
            }
          })();
        }
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
};